<template>
  <report-layout :available-reports="$parent.availableReports" :openedReport="$parent.openedReport" close-path="/team/reports">
    <template v-slot:header>
      <h1 class="info-headline mt-3">{{$t(`personal-results:title-${reportName}`)}}</h1>
      <h5 class="mb-4"><span>{{ $t(`personal-results:description-${reportName}`) }}</span></h5>
    </template>
    <div v-if="!$parent.loading && $parent.historyRecommendationReport && Object.keys($parent.historyRecommendationReport).length > 0">

      <b-row align-v="center" align-h="left" class="mt-3">
        <b-col cols="12" sm="12" md="10" lg="10" offset-md="1" offset-lg="1">
          <p class="tidbit">{{$t('common:updated')}} {{latestReportMonth.recommendation.responses.newestAnswer | moment('from')}}.
            {{$t('common:report-response-info', { respondents: latestReportMonth.recommendation.responses.totalRespondents })}}
            <b v-if="(latestReportMonth.recommendation.responses.totalRespondents / maxRespondents) < 0.5">
              {{$t('common:report-response-warning', { currentRespondents: latestReportMonth.recommendation.responses.totalRespondents, maxRespondents: maxRespondents })}}
            </b>
          </p>
        </b-col>
      </b-row>

      <b-row align-v="center" align-h="center" class="mt-5 pb-5">
        <b-col cols="12" md="5" class="mb-3 mb-md-0">
          <h3 class="feedback-title">
            <span>{{ $t(`team-results:${reportName}-score-title`) }}</span>
          </h3>
        </b-col>
        <b-col cols="12" sm="12" md="5">
          <b-row>
            <b-col>
              <div class="overall-score">
                <span class="--value">{{$parent.recommendationToIndex(latestReportMonth.recommendation.average)}}</span>
                <span class="--scale"> / ±100</span>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="animated-bar has-negative">
                <div v-if="latestReportMonth.recommendation.average < 0" class="meter negative activated" :style="{'background-color': $parent.mapAdvocacyColor(latestReportMonth.recommendation.average), 'width': $parent.formatPercent(($parent.recommendationToIndex(latestReportMonth.recommendation.average)/-200))}"></div>
                <div v-else class="meter activated" style="margin-left: 50%;" :style="{'background-color': $parent.mapAdvocacyColor(latestReportMonth.recommendation.average), 'width': $parent.formatPercent(($parent.recommendationToIndex(latestReportMonth.recommendation.average)/200))}"></div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <!-- <b-row align-v="center" align-h="center" class="mt-2 pb-5">
        <b-col cols="12" sm="12" md="5" order-md="2">
          <b-row>
            <b-col>
              <div class="overall-score">
                <span class="--value">{{$parent.recommendationToIndex(latestReportMonth.recommendation.average) - $parent.recommendationToIndex(previousReportMonth.recommendation.average)}}</span>
                <span class="--scale"> from last quarter</span>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="5" order-md="1">
          <h3 class="feedback-title">
            <span>The advocacy index has gone down a bit.</span>
          </h3>
        </b-col>
      </b-row> -->

      <b-row align-v="center" align-h="center" class="mt-5 pb-5">
        <b-col cols="12" md="5" class="mb-3 mb-md-0">
          <h3 class="feedback-title">
            <span>{{ $t(`team-results:${reportName}-proportion-title`) }}</span>
          </h3>
        </b-col>
        <b-col cols="12" sm="12" md="5">
          <b-row>
            <b-col>
              <doughnut-chart :values="recommendationDonoughtData"/>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row align-v="center" align-h="center" class="mt-5 pb-5">
        <b-col cols="12" md="5" class="mb-3 mb-md-0">
          <h3 class="feedback-title mt-3">
            <span>{{ $t(`team-results:${reportName}-distribution-title`) }}</span>
          </h3>
        </b-col>
        <b-col cols="12" sm="12" md="5">
          <barchart :items="recommendationItems"/>
        </b-col>
      </b-row>

      <b-row v-if="hasHistory" align-v="center" align-h="left" class="mt-5 pb-4 hideOnIE11">
        <b-col cols="12" sm="12" md="10" lg="10" offset-md="1" offset-lg="1">
          <h3 class="feedback-title mt-4 mb-4">
            <span>{{ $t(`team-results:${reportName}-distribution-history-title`) }}</span>
          </h3>
        </b-col>
        <b-col cols="12" sm="12" md="10" lg="10" offset-md="1" offset-lg="1">
          <svg version="1.1" viewBox="0 0 100 25" preserveAspectRatio="xMinYMin meet">
            <g v-for="(report, key, index) in $parent.historyRecommendationReport" v-bind:key="index" :transform="'translate('+ (2.5 + index * 20) + ',0)'">
              <rect ry="0.33" rx="0.33" stroke="white" stroke-weight="1" vector-effect="non-scaling-stroke" fill="#62c829" width="3" :y="23 - 23 * ((report.recommendation.categories['definitely-yes'] / maxRespondents))" :height="23 * ((report.recommendation.categories['definitely-yes'] / maxRespondents))" x="0"/>
              <text style="font-size: 1.0" text-anchor="middle" fill="#888888" x="1.5" :y="22.5 - 23 * ((report.recommendation.categories['definitely-yes'] / maxRespondents))" :height="23 * ((report.recommendation.categories['definitely-yes'] / maxRespondents))">
                {{$parent.formatPercent(((report.recommendation.categories['definitely-yes'] / report.recommendation.responses.totalRespondents)))}}
              </text>
              <rect ry="0.33" rx="0.33" stroke="white" stroke-weight="1" vector-effect="non-scaling-stroke" fill="#a6e682" width="3" :y="23 - 23 * ((report.recommendation.categories['probably-yes'] / maxRespondents))" :height="23 * ((report.recommendation.categories['probably-yes'] / maxRespondents))" x="3"/>
              <text style="font-size: 1.0" text-anchor="middle" fill="#888888" x="4.5" :y="22.5 - 23 * ((report.recommendation.categories['probably-yes'] / maxRespondents))" :height="23 * ((report.recommendation.categories['probably-yes'] / maxRespondents))">
                {{$parent.formatPercent(((report.recommendation.categories['probably-yes'] / report.recommendation.responses.totalRespondents)))}}
              </text>
              <rect ry="0.33" rx="0.33" stroke="white" stroke-weight="1" vector-effect="non-scaling-stroke" fill="#8ed7da" width="3" :y="23 - 23 * ((report.recommendation.categories['not-sure'] / maxRespondents))" :height="23 * ((report.recommendation.categories['not-sure'] / maxRespondents))" x="6"/>
              <text style="font-size: 1.0" text-anchor="middle" fill="#888888" x="7.5" :y="22.5 - 23 * ((report.recommendation.categories['not-sure'] / maxRespondents))" :height="23 * ((report.recommendation.categories['not-sure'] / maxRespondents))">
                {{$parent.formatPercent(((report.recommendation.categories['not-sure'] / report.recommendation.responses.totalRespondents)))}}
              </text>
              <rect ry="0.33" rx="0.33" stroke="white" stroke-weight="1" vector-effect="non-scaling-stroke" fill="#f39c9d" width="3" :y="23 - 23 * ((report.recommendation.categories['probably-not'] / maxRespondents))" :height="23 * ((report.recommendation.categories['probably-not'] / maxRespondents))" x="9"/>
              <text style="font-size: 1.0" text-anchor="middle" fill="#888888" x="10.5" :y="22.5 - 23 * ((report.recommendation.categories['probably-not'] / maxRespondents))" :height="23 * ((report.recommendation.categories['probably-not'] / maxRespondents))">
                {{$parent.formatPercent(((report.recommendation.categories['probably-not'] / report.recommendation.responses.totalRespondents)))}}
              </text>
              <rect ry="0.33" rx="0.33" stroke="white" stroke-weight="1" vector-effect="non-scaling-stroke" fill="#e63333" width="3" :y="23 - 23 * ((report.recommendation.categories['definitely-not'] / maxRespondents))" :height="23 * ((report.recommendation.categories['definitely-not'] / maxRespondents))" x="12"/>
              <text style="font-size: 1.0" text-anchor="middle" fill="#888888" x="13.5" :y="22.5 - 23 * ((report.recommendation.categories['definitely-not'] / maxRespondents))" :height="23 * ((report.recommendation.categories['definitely-not'] / maxRespondents))">
                {{$parent.formatPercent(((report.recommendation.categories['definitely-not'] / report.recommendation.responses.totalRespondents)))}}
              </text>

              <text x="6" y="25" style="font-size: 1.75" text-anchor="middle" :style="{'font-style': index + 1 == Object.keys($parent.historyRecommendationReport).length ? 'italic' : 'normal'}">{{key}}</text>
            </g>
            <line stroke="#888888" x1="0" x2="100" y1="23" y2="23" stroke-width="1" vector-effect="non-scaling-stroke"/>
            <line stroke="#888888" x1="0" x2="0" y1="0" y2="23" stroke-width="1" vector-effect="non-scaling-stroke"/>
          </svg>
          <div class="legends">
            <span class="legend" v-for="(value, index) in recommendationItems" v-bind:key="index">
              <span class="color" :style="{ 'background-color': value.color }"></span>
              <span class="label">{{ value.title }}</span>
            </span>
          </div>
         </b-col>
      </b-row>

      <b-row align-v="center" align-h="left" class="mt-5">
        <b-col cols="12" sm="12" md="10" lg="10" offset-md="1" offset-lg="1">
          <h3 class="feedback-title mt-4 mb-4">
            <span>
              {{ $t('team-results:discussion-ideas-title') }}
            </span>
          </h3>
          <p style="white-space: pre-line;">
            {{ $t('team-results:discussion-ideas-body') }}
          </p>
          <ul>
            <li v-if="latestHasNonAdvocates">{{ $t('team-results:discussion-ideas-non-advocates') }}</li>
            <li v-if="latestHasAdvocates">{{ $t('team-results:discussion-ideas-advocates') }}</li>
            <li>{{ $t('team-results:discussion-ideas-generic') }}</li>
          </ul>
        </b-col>
      </b-row>

    </div>
    <div v-else-if="$parent.loading" class="loadingScreen"></div>
    <div v-else>
      Not enough data to show this report
    </div>
  </report-layout>
</template>
<script>
import BarChart from '../../common/barchart/BarChart'
import ReportLayout from '../../layouts/ReportLayout'
import DoughnutChart from '../../common/doughnut/Doughnut'

export default {
  name: 'TeamAnxietyReport',
  data () {
    return {
      reportName: 'advocacy'
    }
  },
  components: {
    barchart: BarChart,
    ReportLayout,
    DoughnutChart
  },
  mounted: function () {
    this.$parent.openedReport = this.reportName
  },
  computed: {
    recommendationDonoughtData () {
      if (!this.latestReportMonth) {
        return null
      }
      return [
        {
          value: this.latestReportMonth.recommendation.categories['definitely-yes'] + this.latestReportMonth.recommendation.categories['probably-yes'],
          color: '#62c829',
          label: this.$t('team-results:classification-title-advocacy-definitely-yes_probably-yes')
        },
        {
          value: this.latestReportMonth.recommendation.categories['definitely-not'] + this.latestReportMonth.recommendation.categories['probably-not'] + this.latestReportMonth.recommendation.categories['not-sure'],
          color: '#cccccc',
          label: this.$t('team-results:classification-title-advocacy-not-sure_probably-not_definitely-not')
        }
      ]
    },
    latestReportMonth () {
      if (this.$parent.historyRecommendationReport && this.$parent.historyRecommendationReport) {
        const lastReportKey = Object.keys(this.$parent.historyRecommendationReport).sort().pop()
        if (lastReportKey) {
          return this.$parent.historyRecommendationReport[lastReportKey]
        }
      }
      return null
    },
    previousReportMonth () {
      if (this.$parent.historyRecommendationReport && this.$parent.historyRecommendationReport) {
        const keys = Object.keys(this.$parent.historyRecommendationReport).sort()
        if (keys.length > 1) {
          return this.$parent.historyRecommendationReport[keys[keys.length - 2]]
        }
      }
      return null
    },
    maxRespondents () {
      if (this.$parent.historyRecommendationReport && Object.keys(this.$parent.historyRecommendationReport).length > 0) {
        return Object.values(this.$parent.historyRecommendationReport).map(report => report.recommendation.responses.totalRespondents).reduce((a, b) => a > b ? a : b, 0)
      }
      return null
    },
    latestHasAdvocates () {
      if (this.latestReportMonth) {
        return this.latestReportMonth.recommendation.categories['probably-yes'] + this.latestReportMonth.recommendation.categories['definitely-yes']
      }
      return null
    },
    latestHasNonAdvocates () {
      if (this.latestReportMonth) {
        return this.latestReportMonth.recommendation.categories['not-sure'] + this.latestReportMonth.recommendation.categories['probably-not'] + this.latestReportMonth.recommendation.categories['definitely-not']
      }
      return null
    },
    hasHistory () {
      if (this.$parent.historyRecommendationReport && Object.keys(this.$parent.historyRecommendationReport).length > 1) {
        return true
      }
      return false
    },
    recommendationItems: function () {
      if (!this.latestReportMonth) {
        return []
      }
      return [
        {
          title: this.$t('team-results:classification-title-advocacy-definitely-yes'),
          percentage: this.$parent.formatPercent(this.latestReportMonth.recommendation.categories['definitely-yes'] / this.latestReportMonth.recommendation.responses.totalRespondents),
          color: '#62c829'
        },
        {
          title: this.$t('team-results:classification-title-advocacy-probably-yes'),
          percentage: this.$parent.formatPercent(this.latestReportMonth.recommendation.categories['probably-yes'] / this.latestReportMonth.recommendation.responses.totalRespondents),
          color: '#a6e682'
        },
        {
          title: this.$t('team-results:classification-title-advocacy-not-sure'),
          percentage: this.$parent.formatPercent(this.latestReportMonth.recommendation.categories['not-sure'] / this.latestReportMonth.recommendation.responses.totalRespondents),
          color: '#8ed7da'
        },
        {
          title: this.$t('team-results:classification-title-advocacy-probably-not'),
          percentage: this.$parent.formatPercent(this.latestReportMonth.recommendation.categories['probably-not'] / this.latestReportMonth.recommendation.responses.totalRespondents),
          color: '#f39c9d'
        },
        {
          title: this.$t('team-results:classification-title-advocacy-definitely-not'),
          percentage: this.$parent.formatPercent(this.latestReportMonth.recommendation.categories['definitely-not'] / this.latestReportMonth.recommendation.responses.totalRespondents),
          color: '#e63333'
        }
      ]
    }
  }
}
</script>
<style lang="scss">
  .svg-container {
    display: inline-block;
    position: relative;
    width: 100%;
    padding-bottom: 100%;
    vertical-align: middle;
    overflow: hidden;
  }
  .svg-content {
    display: inline-block;
    position: absolute;
    top: 0;
    left: 0;
  }
</style>

<style lang="scss" scoped>
.legends {
  margin-top: 1rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  .legend {
    margin-right: 1rem;
    margin-bottom: 0.5rem;
    display: flex;
    line-height: 1;
    font-size: 0.75em;
    .color {
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: 1em 1em;
      width: 1em;
      height: 1em;
      border-radius: 0.1em;
      margin-right: 0.25rem;
    }
    .label {
      font-weight: normal;
    }
  }
}

@media all and (-ms-high-contrast:none) {
  //  .foo { color: green } /* IE10 */
  *::-ms-backdrop, .hideOnIE11 { /* IE11 */
    display: none;
  }
}
</style>
